import { getRentalsRailV2, KuxFilteredCategoriesDTO, KuxMovieType, UIDAPresentationTypeEnum } from '@kaltura-ott/tvpil';
import { action } from 'mobx';
import { lastValueFrom } from 'rxjs';

import { CardPlaceholder, EntitiesType, VodAsset } from '../../../../entities';
import { addPurchasableAttribute, addRentalAttribute, creatorEntityStore } from '../../../../entities/entities.service';
import { getItemsInPage, DEFAULT_PAGE_SIZE } from '../rail-store-helper-v2';
import { RailStoreV2 } from '../rail-store-v2';

// TODO rental rail consists of VodAssets
export class RentalsRailStoreV2 extends RailStoreV2<EntitiesType> {
  subtype: UIDAPresentationTypeEnum.tvod = UIDAPresentationTypeEnum.tvod;

  constructor(categoryTree: KuxFilteredCategoriesDTO, parentCategoryTree: KuxFilteredCategoriesDTO, children?: []) {
    super(categoryTree, parentCategoryTree, children);
  }

  protected async getData(
    pageIndex: number,
    items: (EntitiesType | CardPlaceholder)[],
  ): Promise<{
    items: (EntitiesType | CardPlaceholder)[];
    totalCount: number;
    newItems: EntitiesType[];
  }> {
    const newRailData = await lastValueFrom(
      getRentalsRailV2({
        pageSize: DEFAULT_PAGE_SIZE,
        pageIndex: pageIndex,
        kSql: this.aggregatedKSQL,
        groupBy: this.groupBy,
        isGroupedGrid: this.categoryTree.railProperty.isGroupedGrid,
      }),
    );

    const newItems = newRailData.items.slice(0, this.pageSize).map((item) => creatorEntityStore(item as KuxMovieType));

    this.innerItems.push(...newItems);
    return { items: this.items, totalCount: newRailData.totalCount, newItems };
  }

  protected async getAdditionData(itemsInPage: EntitiesType[]): Promise<void> {
    addRentalAttribute(itemsInPage as VodAsset[], true);
    addPurchasableAttribute(itemsInPage as VodAsset[], false);
  }

  @action
  protected async restoreAdditionData(pageIndex: number, items: EntitiesType[]): Promise<void> {
    const itemsInPage = getItemsInPage(items, pageIndex);
    addRentalAttribute(itemsInPage as VodAsset[], false);
    addPurchasableAttribute(itemsInPage as VodAsset[], false);
    return this.getAdditionData(itemsInPage);
  }
}
